/** @format */
import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UIRouterGlobals } from '@uirouter/core';
import { Subscription } from 'rxjs';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common/types/angular-hybrid';
import { NavUtilsService } from '../../service/nav-utils.service';
import { BreadcrumbItem, HeaderService } from '../header.service';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.downgraded.breadcrumbs',
        directiveName: 'sisBreadcrumbs',
    };

    changeDetectorRef = inject(ChangeDetectorRef);

    breadcrumbs: BreadcrumbItem[] = [];
    homeUrl: string;

    private subscriptions: Subscription[] = [];

    constructor(
        navUtilsService: NavUtilsService,
        private headerService: HeaderService,
        private uiRouterGlobals: UIRouterGlobals,
    ) {
        this.homeUrl = navUtilsService.getHomeUrl();
    }

    ngOnInit(): void {
        this.subscriptions = [
            this.headerService.breadcrumbsChanged.subscribe(breadcrumbs => {
                this.breadcrumbs = breadcrumbs;
                // While this component uses Default change detection strategy, it is possible that the change detection
                // is not triggered when this component is used under an OnPush parent component. Use markForCheck to
                // ensure that this component is marked dirty and will be checked in next change detection cycle.
                // Note: this should probably be refactored to use signals or async pipe, but for now this is a safe fix.
                this.changeDetectorRef.markForCheck();
            }),
        ];
    }

    ngOnDestroy(): void {
        this.subscriptions?.forEach(sub => sub.unsubscribe());
    }

    get showBreadcrumbs(): boolean {
        return !this.uiRouterGlobals.$current?.data?.headerWithoutBreadcrumbs;
    }

    get showHomeNode(): boolean {
        return this.uiRouterGlobals.$current?.data?.showHome === true;
    }

    get showLastNode(): boolean {
        return this.uiRouterGlobals.$current?.data?.hideLastNode === false;
    }
}
